export var BASE_USER_EMAILS_KEY = 'user-emails';
var userEmailsKeys = {
  userEmails: [BASE_USER_EMAILS_KEY]
};
export default userEmailsKeys;